import React from 'react';
import { useTheme } from '../../context'; 

import Error from '../error';


const ErrorContainer: React.FC = () => {
    const { theme } = useTheme();
    
    return (
        <div 
            className={`flex-grow min-h-screen   ${
                theme === "dark" 
                    ? "bg-[rgb(19,18,18)] text-white" 
                    : "bg-[rgb(221,227,230)] text-black"
            } relative`}
        >  
            
            <Error />
            
        </div>
    );
};

export default ErrorContainer;